<template>
  <div>
    <search-nav @handleSearch="handleSearch">
      <search-nav-year-month class="mr-4" label="연도" v-model="search.date" :useAllYear="true" type="year" />
      <div class="flex items-center">
        <div class="label-text mr-4">부서</div>
        <ml-input v-model="search.fieldName" class="w-full flex-1" @keyup="keyupEvent" />
      </div>
    </search-nav>

    <!-- table -->
    <div class="overflow-x-auto" style="margin-bottom: 60px">
      <table class="w-full">
        <colgroup>
          <col width="80" />
          <col width="160" />
          <col width="340" />
          <col width="250" />
          <col width="250" />
        </colgroup>
        <thead>
          <tr>
            <th rowspan="2">연번</th>
            <th rowspan="2">연도</th>
            <th rowspan="2">부서</th>
            <th colspan="2">유해위험요인</th>
          </tr>
          <tr>
            <th>발굴건수</th>
            <th>확정건수</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in list" :key="item.부서">
            <td>{{ index+1 }}</td>
            <td>{{ item.연도 }}</td>
            <td>{{ item.부서 }}</td>
            <td>{{ item.발굴건수 }}</td>
            <td>{{ item.확정건수 }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th colspan="3">계</th>
            <th>{{ total.발굴건수 }}</th>
            <th>{{ total.확정건수 }}</th>
          </tr>
        </tfoot>
      </table>
    </div>

  </div>
</template>

<script>
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import SearchNav from "@/components/nav/SearchNav.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  name: "monitoring",
  components: {SearchNav, SearchNavYearMonth},

  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    total() {
      return {
        발굴건수: this.list.reduce((acc, cur) => acc + cur.발굴건수, 0),
        확정건수: this.list.reduce((acc, cur) => acc + cur.확정건수, 0),
      }
    },
  },
  data() {
    return {
      search: {
        date: { year: new Date().getFullYear(), month: '', half: '' },
        fieldName: '',
      },

      list: [],

    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading(true);
      const params = {
        projectId: this.projectId,
        boardIds: [671, 965],
        depth: 1,
        dateField: 'created_at',
        countFields: ['body.stdInfo.field_name'],
      };

      if (this.search.date.year) {
        params.currentYear = this.search.date.year;
      }

      const data = await this.$store.dispatch("summary/LOAD_DONUT_89_DETAIL", params);
      this.list = this.convertData(data)
      this.loading(false);
    },
    convertData (data) {
      if (!data) return []

      const obj = {};
      for (const year of Object.keys(data.board)) {
        for (const month of Object.keys(data.board[year])) {
          for (const board of data.board[year][month]) {
            const boardId = board.id
            for (const field of Object.keys(board.custom['body.stdInfo.field_name'])) {
              const count = board.custom['body.stdInfo.field_name'][field].count

              if (!obj[year]) obj[year] = {}
              if (!obj[year][field]) obj[year][field] = {}
              if (!obj[year][field]['발굴건수']) obj[year][field]['발굴건수'] = 0
              if (!obj[year][field]['확정건수']) obj[year][field]['확정건수'] = 0

              if (boardId === 671) {
                obj[year][field]['발굴건수'] += count
              } else if (boardId === 965) {
                obj[year][field]['확정건수'] += count
              }
            }
          }
        }
      }


      const list = []
      for (const year of Object.keys(obj)) {
        for (const field of Object.keys(obj[year])) {

          if (!this.search.fieldName || field.includes(this.search.fieldName)) {
            list.push({
              연도: year,
              부서: field,
              발굴건수: obj[year][field]['발굴건수'],
              확정건수: obj[year][field]['확정건수'],
            })
          }
        }
      }

      return list;
    },
    handleSearch() {
      this.loadData();
    },
    keyupEvent (event) {
      if (event.code === 'NumpadEnter' || event.code === 'Enter') {
        this.handleSearch()
      }
    },

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },
  }
}
</script>

<style scoped lang="scss">
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  tbody {
    td {
      padding: 6px;
    }
  }

  th {
    text-align: center;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    background: #f9f9f9;
    border: 1px solid #cdcdcd;
    padding: 16px 0;

    &:first-child {
      padding: 0;
    }
  }

  td {
    border: 1px solid #cdcdcd;
    text-align: center;
    justify-items: center;
    padding: 7px;
    background-color: #fff;
  }
}
</style>
